var render, staticRenderFns
import script from "./cComponent.vue?vue&type=script&lang=js&"
export * from "./cComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889adff8",
  null
  
)

export default component.exports